// ============================================================
//  ALTIMO Medical Center — CuentaPaciente.jsx  (v2)
//  Cambios v2:
//    ✓ Modal de receta para medicamentos controlados
//    ✓ Validación en frontend antes de llamar al backend
//    ✓ Muestra número de receta y prescriptor en la tabla
//    ✓ Muestra lote despachado en cargos de medicamentos
//    ✓ Badge CONTROLADO visible al buscar en inventario
// ============================================================

import { useState, useEffect, useCallback } from 'react';
import api from '../apiClient';
import { useConfirmar } from './ModalConfirmar';
import TooltipAyuda from './TooltipAyuda';

const S = {
  pagina:{ background:'#f0f4f8', minHeight:'100vh', padding:'20px', fontFamily:'Segoe UI, sans-serif' },
  fila:  { display:'flex', gap:'14px', marginBottom:'16px' },
  card:  { background:'#fff', borderRadius:'10px', border:'1px solid #dde3ea', padding:'18px', marginBottom:'16px' },
  cardTitulo:{ fontSize:'12px', fontWeight:'700', color:'#1B2A5E', textTransform:'uppercase',
               letterSpacing:'.05em', marginBottom:'14px', paddingBottom:'10px',
               borderBottom:'2px solid #e8f0fb', display:'flex', justifyContent:'space-between', alignItems:'center' },
  tabla: { width:'100%', borderCollapse:'collapse', fontSize:'13px' },
  th:    { textAlign:'left', padding:'8px 12px', fontSize:'11px', color:'#6c757d', fontWeight:'600',
           borderBottom:'2px solid #e8f0fb', background:'#f8fafd' },
  td:    { padding:'9px 12px', borderBottom:'1px solid #eef1f6', color:'#333', verticalAlign:'middle' },
  totalRow:  { display:'flex', justifyContent:'space-between', padding:'7px 4px', fontSize:'13px', color:'#333' },
  totalFinal:{ display:'flex', justifyContent:'space-between', padding:'10px 4px', fontSize:'16px',
               fontWeight:'700', color:'#1B2A5E', borderTop:'2px solid #e8f0fb', marginTop:'6px' },
  btnPrimario:  { background:'#1D9E75', color:'#fff', border:'none', borderRadius:'7px',
                  padding:'8px 18px', fontSize:'13px', fontWeight:'700', cursor:'pointer' },
  btnAzul:      { background:'#1B2A5E', color:'#fff', border:'none', borderRadius:'7px',
                  padding:'8px 16px', fontSize:'13px', fontWeight:'600', cursor:'pointer' },
  btnSecundario:{ background:'#fff', color:'#495057', border:'1px solid #c0ccda', borderRadius:'7px',
                  padding:'7px 14px', fontSize:'12px', cursor:'pointer' },
  btnPeligro:   { background:'#fff', color:'#dc3545', border:'1px solid #f5c6cb', borderRadius:'7px',
                  padding:'5px 10px', fontSize:'11px', cursor:'pointer' },
  input: { width:'100%', fontSize:'13px', padding:'7px 10px', border:'1px solid #c0ccda',
           borderRadius:'7px', background:'#fff', color:'#333', outline:'none', boxSizing:'border-box' },
  label: { display:'block', fontSize:'11px', fontWeight:'600', color:'#6c757d',
           marginBottom:'4px', textTransform:'uppercase', letterSpacing:'.04em' },
  campo: { marginBottom:'12px' },
  alerta:(tipo)=>({
    padding:'10px 14px', borderRadius:'8px', fontSize:'13px', fontWeight:'500', marginBottom:'12px',
    background:tipo==='ok'?'#d4edda':tipo==='err'?'#f8d7da':'#fff3cd',
    color:tipo==='ok'?'#155724':tipo==='err'?'#721c24':'#856404',
    border:`1px solid ${tipo==='ok'?'#c3e6cb':tipo==='err'?'#f5c6cb':'#ffc107'}`,
  }),
  alertaControlado: {
    background:'#f3e5f5', border:'2px solid #9c27b0', borderRadius:'10px',
    padding:'14px 16px', marginBottom:'14px',
  },
  pill:(tipo)=>{
    const map={
      Habitacion:   { bg:'#cce5ff',color:'#004085' },
      Medicamento:  { bg:'#d4edda',color:'#155724' },
      Procedimiento:{ bg:'#e2d9f3',color:'#4a2080' },
      Examen:       { bg:'#fff3cd',color:'#856404' },
      Honorario:    { bg:'#f4c0d1',color:'#72243E' },
      Insumo:       { bg:'#d1ecf1',color:'#0c5460' },
      Otro:         { bg:'#e2e3e5',color:'#383d41' },
    };
    const c=map[tipo]||map.Otro;
    return { display:'inline-block',padding:'2px 8px',borderRadius:'99px',
             fontSize:'10px',fontWeight:'600',background:c.bg,color:c.color };
  },
  badgeControlado: {
    display:'inline-block', padding:'2px 8px', borderRadius:'99px',
    fontSize:'10px', fontWeight:'700', background:'#f3e5f5',
    color:'#6a1b9a', border:'1px solid #ce93d8', marginLeft:'6px',
  },
  modal:    { position:'fixed',top:0,left:0,right:0,bottom:0,
              background:'rgba(0,0,0,0.45)',display:'flex',
              alignItems:'center',justifyContent:'center',zIndex:1000,overflowY:'auto' },
  modalCard:{ background:'#fff',borderRadius:'12px',padding:'24px',width:'520px',
              border:'1px solid #dde3ea',maxHeight:'92vh',overflowY:'auto',margin:'auto' },
};

const TIPOS_ITEM = ['Medicamento','Procedimiento','Examen','Honorario','Insumo','Otro'];

// ════════════════════════════════════════════════════════════
//  MODAL AGREGAR ÍTEM
// ════════════════════════════════════════════════════════════
function ModalAgregarItem({ admision_id, usuario, onGuardado, onCerrar }) {
  const [tipo,           setTipo]           = useState('Medicamento');
  const [busqueda,       setBusqueda]       = useState('');
  const [resultados,     setResultados]     = useState([]);
  const [seleccion,      setSeleccion]      = useState(null);
  const [cantidad,       setCantidad]       = useState(1);
  const [precioManual,   setPrecioManual]   = useState('');
  const [guardando,      setGuardando]      = useState(false);
  const [error,          setError]          = useState('');
  const [esLibre,        setEsLibre]        = useState(false);

  // ── Campos de receta (controlados) ──
  const [numReceta,      setNumReceta]      = useState('');
  const [drPrescriptor,  setDrPrescriptor]  = useState('');

  const esMedInsumo       = tipo === 'Medicamento' || tipo === 'Insumo';
  const requiereSeleccion = esMedInsumo && !esLibre;
  const esControlado      = !esLibre && seleccion?.es_controlado === 1;

  const cambiarTipo = (t) => {
    setTipo(t); setSeleccion(null); setBusqueda('');
    setResultados([]); setPrecioManual(''); setEsLibre(false);
    setNumReceta(''); setDrPrescriptor('');
  };

  const toggleLibre = (val) => {
    setEsLibre(val);
    if (val) { setSeleccion(null); setResultados([]); setNumReceta(''); setDrPrescriptor(''); }
    else     { setBusqueda(''); }
  };

  useEffect(() => {
    if (busqueda.length < 2 || esLibre) { setResultados([]); return; }
    const t = setTimeout(async () => {
      const r = esMedInsumo
        ? await api.inventario.buscar(busqueda)
        : await api.tarifario.buscar(busqueda);
      if (r.ok) setResultados(r.data.slice(0, 8));
    }, 300);
    return () => clearTimeout(t);
  }, [busqueda, tipo, esLibre]);

  const seleccionar = (item) => {
    setSeleccion({
      id:            item.id,
      nombre:        item.nombre,
      precio:        esMedInsumo ? item.precio_unitario : item.precio,
      es_controlado: item.es_controlado || 0,
      stock:         item.stock,
      unidad:        item.unidad,
    });
    setBusqueda(item.nombre);
    setResultados([]);
    setPrecioManual('');
    // Si cambia la selección y no era controlado antes, limpiar receta
    if (!item.es_controlado) { setNumReceta(''); setDrPrescriptor(''); }
  };

  // Para Procedimiento, Examen, Honorario, Otro: precio siempre manual (varía cada vez)
  const esPrecioSiempreManual = ['Procedimiento','Examen','Honorario','Otro'].includes(tipo);
  // precioFinal: usa lo que escribió el usuario; si no, usa tarifario SOLO para Med/Insumo
  const precioFinal = precioManual !== '' ? parseFloat(precioManual)
                    : esPrecioSiempreManual ? 0
                    : (seleccion?.precio || 0);
  const totalItem   = Math.round(cantidad * precioFinal * 100) / 100;

  const handleGuardar = async () => {
    if (requiereSeleccion && !seleccion) {
      setError('Selecciona un ítem del inventario, o activa "No está en inventario".'); return;
    }
    if (!busqueda.trim()) { setError('Ingresa una descripción.'); return; }
    if (cantidad <= 0)    { setError('La cantidad debe ser mayor a 0.'); return; }
    // Para Procedimiento/Examen/Honorario/Otro: precio siempre debe ingresarse manualmente
    if (esPrecioSiempreManual && precioManual === '') {
      setError('Ingresa el precio para este ' + tipo.toLowerCase() + '.'); return;
    }
    // Para Medicamento/Insumo libre sin precio
    if (!esPrecioSiempreManual && esLibre && precioManual === '') {
      setError('Ingresa el precio unitario.'); return;
    }
    if (precioFinal < 0) { setError('El precio no puede ser negativo.'); return; }

    // Validación frontend para controlados
    if (esControlado) {
      if (!numReceta.trim()) {
        setError('Este medicamento es CONTROLADO. Ingresa el número de receta médica.'); return;
      }
      if (!drPrescriptor.trim()) {
        setError('Este medicamento es CONTROLADO. Ingresa el nombre del médico prescriptor.'); return;
      }
    }

    setGuardando(true); setError('');
    const r = await api.cuenta.agregarItem({
      admision_id,
      tipo,
      referencia_id:   (!esLibre && seleccion?.id) ? seleccion.id : null,
      descripcion:     busqueda.trim(),
      cantidad:        parseFloat(cantidad),
      precio_unitario: precioFinal,
      usuario_id:      usuario.id,
      num_receta:      esControlado ? numReceta.trim()      : null,
      dr_prescriptor:  esControlado ? drPrescriptor.trim()  : null,
    });
    setGuardando(false);
    if (r.ok) onGuardado();
    else setError(r.error || 'Error al guardar');
  };

  return (
    <div style={S.modal} onClick={onCerrar}>
      <div style={S.modalCard} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:'15px', fontWeight:'700', color:'#1B2A5E', marginBottom:'18px' }}>
          Agregar cargo a la cuenta
        </div>

        {error && <div style={S.alerta('err')}>{error}</div>}

        {/* Tipo */}
        <div style={S.campo}>
          <label style={S.label}>Tipo</label>
          <select style={S.input} value={tipo} onChange={e => cambiarTipo(e.target.value)}>
            {TIPOS_ITEM.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>

        {/* Toggle libre */}
        {esMedInsumo && (
          <div style={{ background:esLibre?'#fff8e1':'#f8fafd', border:`1px solid ${esLibre?'#ffe082':'#dde3ea'}`, borderRadius:'8px', padding:'10px 14px', marginBottom:'12px' }}>
            <label style={{ display:'flex', alignItems:'center', gap:'10px', cursor:'pointer', fontSize:'13px', fontWeight:'600', color:esLibre?'#e65100':'#495057' }}>
              <input type="checkbox" checked={esLibre} onChange={e => toggleLibre(e.target.checked)}
                style={{ width:'15px', height:'15px' }} />
              {tipo==='Insumo' ? '📦 Este insumo no está en el inventario del sistema' : '💊 Este medicamento no está en el inventario del sistema'}
            </label>
            {esLibre && (
              <div style={{ fontSize:'11px', color:'#795548', marginTop:'6px' }}>
                ⚠ Se registrará el cargo sin descontar stock ni requerir receta.
              </div>
            )}
          </div>
        )}

        {/* Búsqueda / descripción */}
        <div style={S.campo}>
          <label style={S.label}>
            {esLibre ? `Nombre del ${tipo.toLowerCase()} *`
              : esMedInsumo ? 'Buscar en inventario' : 'Buscar en tarifario'}
          </label>
          <input
            style={{ ...S.input, border: esLibre ? '2px solid #ff9800' : '1px solid #c0ccda' }}
            value={busqueda}
            onChange={e => { setBusqueda(e.target.value); if (!esLibre) setSeleccion(null); }}
            placeholder={esLibre ? `Escribe el nombre...` : 'Escriba para buscar...'}
            autoFocus={esLibre}
          />

          {/* Resultados */}
          {!esLibre && resultados.length > 0 && (
            <div style={{ border:'1px solid #dde3ea', borderRadius:'7px', marginTop:'4px', background:'#fff', maxHeight:'180px', overflowY:'auto' }}>
              {resultados.map(r => (
                <div key={r.id}
                  style={{ padding:'8px 12px', cursor:'pointer', fontSize:'13px', borderBottom:'1px solid #f0f4f8' }}
                  onMouseEnter={e => e.currentTarget.style.background='#f0f4f8'}
                  onMouseLeave={e => e.currentTarget.style.background='#fff'}
                  onClick={() => seleccionar(r)}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <span>
                      <strong>{r.nombre}</strong>
                      {r.es_controlado === 1 && (
                        <span style={S.badgeControlado}>CONTROLADO</span>
                      )}
                    </span>
                    <span style={{ color:'#6c757d', fontSize:'12px', whiteSpace:'nowrap', marginLeft:'8px' }}>
                      ${(r.precio_unitario||r.precio||0).toFixed(2)}
                      {r.stock !== undefined && ` · Stock: ${r.stock} ${r.unidad}`}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Selección confirmada */}
          {!esLibre && seleccion && (
            <div style={{ marginTop:'6px', padding:'8px 10px', background:'#d4edda', borderRadius:'6px', fontSize:'12px', color:'#155724', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span>
                ✓ {seleccion.nombre}
                {seleccion.es_controlado === 1 && <span style={S.badgeControlado}>CONTROLADO</span>}
              </span>
              {/* No mostrar precio precargado para tipos que siempre requieren precio manual */}
              {!esPrecioSiempreManual && (
                <span style={{ fontWeight:'700' }}>${Number(seleccion.precio).toFixed(2)}</span>
              )}
              {esPrecioSiempreManual && (
                <span style={{ fontSize:'11px', color:'#e67e22', fontWeight:'700' }}>⚡ Ingresa el precio</span>
              )}
            </div>
          )}
        </div>

        {/* ── SECCIÓN RECETA — visible solo si es controlado ── */}
        {esControlado && (
          <div style={S.alertaControlado}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'12px' }}>
              <span style={{ fontSize:'18px' }}>⚠️</span>
              <div>
                <div style={{ fontWeight:'800', color:'#6a1b9a', fontSize:'13px' }}>
                  MEDICAMENTO CONTROLADO — Requiere receta médica obligatoria
                </div>
                <div style={{ fontSize:'11px', color:'#7b1fa2', marginTop:'2px' }}>
                  El despacho quedará bloqueado si no se ingresa la receta y el prescriptor.
                </div>
              </div>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
              <div style={S.campo}>
                <label style={{ ...S.label, color:'#6a1b9a' }}>N° de receta médica *</label>
                <input
                  style={{ ...S.input, border:'2px solid #9c27b0', background:'#fce4ec' }}
                  value={numReceta}
                  onChange={e => setNumReceta(e.target.value.toUpperCase())}
                  placeholder="RX-2026-00001"
                  autoFocus
                />
              </div>
              <div style={S.campo}>
                <label style={{ ...S.label, color:'#6a1b9a' }}>Médico prescriptor *</label>
                <input
                  style={{ ...S.input, border:'2px solid #9c27b0', background:'#fce4ec' }}
                  value={drPrescriptor}
                  onChange={e => setDrPrescriptor(e.target.value.toUpperCase())}
                  placeholder="Dr. / Dra. NOMBRE APELLIDO"
                />
              </div>
            </div>

            {numReceta.trim() && drPrescriptor.trim() && (
              <div style={{ fontSize:'11px', color:'#388e3c', fontWeight:'600', marginTop:'4px' }}>
                ✓ Receta registrada — el despacho quedará autorizado
              </div>
            )}
          </div>
        )}

        {/* Cantidad, precio, total */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px' }}>
          <div style={S.campo}>
            <label style={S.label}>Cantidad</label>
            <input style={S.input} type="number" min="0.01" step="0.01"
              value={cantidad} onChange={e => setCantidad(e.target.value)} />
          </div>
          <div style={S.campo}>
            <label style={S.label}>
              Precio unitario ($)
              {esPrecioSiempreManual && seleccion && (
                <span style={{ marginLeft:'6px', fontSize:'10px', fontWeight:'700', color:'#e67e22' }}>
                  ⚡ Ingresa el monto — puede variar
                </span>
              )}
              {!esPrecioSiempreManual && seleccion && (Number(seleccion.precio) === 0 || seleccion.precio === null) && (
                <span style={{ marginLeft:'6px', fontSize:'10px', fontWeight:'700', color:'#e67e22' }}>
                  ⚡ Sin precio fijo — ingresa el monto
                </span>
              )}
            </label>
            <input
              style={{
                ...S.input,
                border: (esPrecioSiempreManual || (seleccion && (Number(seleccion.precio) === 0 || seleccion.precio === null))) && precioManual === ''
                  ? '2px solid #ff9800' : '1px solid #c0ccda',
              }}
              type="number" min="0" step="0.01"
              // Para tipos manuales: NUNCA pre-poblar el precio aunque exista en tarifario
              value={precioManual}
              onChange={e => setPrecioManual(e.target.value)}
              placeholder="0.00 — ingresa el monto"
            />
          </div>
          <div style={S.campo}>
            <label style={S.label}>Total</label>
            <div style={{ ...S.input, background:'#f8fafd', color:'#1B2A5E', fontWeight:'700' }}>
              ${totalItem.toFixed(2)}
            </div>
          </div>
        </div>

        <div style={{ display:'flex', gap:'10px', marginTop:'6px' }}>
          <button style={S.btnPrimario} onClick={handleGuardar} disabled={guardando}>
            {guardando ? 'Guardando...' : 'Agregar a la cuenta'}
          </button>
          <button style={S.btnSecundario} onClick={onCerrar}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════
//  COMPONENTE PRINCIPAL
// ════════════════════════════════════════════════════════════
export default function CuentaPaciente({ usuario, admisionId: propAdmisionId, onIrFacturacion }) {
  const [busAdmision,   setBusAdmision]   = useState('');
  const [textoBusq,     setTextoBusq]     = useState('');
  const [resultsBusq,   setResultsBusq]   = useState([]);
  const [buscandoTexto, setBuscandoTexto] = useState(false);
  const [admisionId,    setAdmisionId]    = useState(propAdmisionId || null);
  const [admision,      setAdmision]      = useState(null);
  const [items,         setItems]         = useState([]);
  const [totales,       setTotales]       = useState({ subtotal:0, iva:0, total:0 });
  const [cargando,      setCargando]      = useState(false);
  const [modalAbierto,  setModalAbierto]  = useState(false);
  const [mensaje,       setMensaje]       = useState(null);
  const [cerrandoCuenta,   setCerrandoCuenta]   = useState(false);
  const [reabriendoCuenta, setReabriendoCuenta] = useState(false);
  const { confirmar, ModalConfirmarUI } = useConfirmar();

  const cargarCuenta = useCallback(async (id) => {
    if (!id) return;
    setCargando(true);
    const [rAdm, rItems, rTotal] = await Promise.all([
      api.admisiones.obtener(id),
      api.cuenta.items(id),
      api.cuenta.total(id),
    ]);
    if (rAdm.ok)   setAdmision(rAdm.data);
    if (rItems.ok) setItems(rItems.data);
    if (rTotal.ok) setTotales(rTotal.data);
    setCargando(false);
  }, []);

  useEffect(() => { if (admisionId) cargarCuenta(admisionId); }, [admisionId, cargarCuenta]);
  useEffect(() => { setAdmisionId(propAdmisionId || null); }, [propAdmisionId]);

  // Búsqueda en tiempo real por nombre, DUI o expediente/código
  useEffect(() => {
    if (textoBusq.trim().length < 2) { setResultsBusq([]); return; }
    const t = setTimeout(async () => {
      setBuscandoTexto(true);
      try {
        const r = await api.admisiones.buscar(textoBusq.trim());
        if (r.ok) setResultsBusq(r.data || []);
      } finally {
        setBuscandoTexto(false);
      }
    }, 350);
    return () => clearTimeout(t);
  }, [textoBusq]);

  const buscarAdmision = async () => {
    if (!busAdmision) return;
    const texto = busAdmision.trim();
    if (!texto) return;

    const r = await api.admisiones.buscar(texto);
    if (r.ok && r.data?.length > 0) {
      setResultsBusq([]);
      setTextoBusq('');
      setMensaje(null);
      setAdmisionId(r.data[0].id);
    } else {
      setMensaje({ tipo:'err', texto:'No se encontró ningún expediente con esos datos.' });
    }
  };

  const anularItem = async (item) => {
    if (!(await confirmar({
      texto: `¿Anular el cargo "${item.descripcion}"?`,
      tipo: 'advertencia',
      textoConfirmar: 'Anular cargo',
    }))) return;
    const r = await api.cuenta.anularItem(item.id, { motivo:'Anulado por usuario', usuario_id:usuario.id });
    if (r.ok) { setMensaje({ tipo:'ok', texto:'Cargo anulado.' }); cargarCuenta(admisionId); }
    else setMensaje({ tipo:'err', texto: r.error });
  };

  // ── Cierre de cuenta (caja): consolida TODOS los cargos pendientes
  // (habitación recalculada con días reales, medicina, exámenes,
  // honorarios, insumos/equipos) y bloquea nuevos cargos/anulaciones.
  const cerrarCuenta = async () => {
    if (!(await confirmar({
      texto:
        `¿Cerrar la cuenta de ${admision.paciente}?\n\n` +
        `Se consolidará el total final (incluyendo días de habitación hasta hoy) ` +
        `y ya NO se podrán agregar ni anular cargos. Después de cerrar, la cuenta ` +
        `quedará lista para facturar.`,
      tipo: 'peligro',
      textoConfirmar: 'Cerrar cuenta',
    }))) return;
    setCerrandoCuenta(true);
    try {
      const r = await api.cuenta.cerrar({ admision_id: admisionId, usuario_id: usuario.id });
      if (r.ok) {
        setMensaje({ tipo:'ok', texto:`✓ Cuenta cerrada. Total consolidado: $${Number(r.data?.totales?.total || 0).toFixed(2)}. Ya puedes ir a facturación.` });
        cargarCuenta(admisionId);
      } else {
        setMensaje({ tipo:'err', texto: r.error });
      }
    } finally {
      setCerrandoCuenta(false);
    }
  };

  // ── Reabrir cuenta: solo si AÚN no se ha emitido factura (validado en backend) ──
  const reabrirCuenta = async () => {
    const motivo = window.prompt('Motivo para reabrir la cuenta (quedará en la auditoría):', '');
    if (motivo === null) return; // canceló el prompt
    setReabriendoCuenta(true);
    try {
      const r = await api.cuenta.reabrir({ admision_id: admisionId, motivo, usuario_id: usuario.id });
      if (r.ok) {
        setMensaje({ tipo:'ok', texto:'✓ Cuenta reabierta. Ya se pueden agregar/anular cargos nuevamente.' });
        cargarCuenta(admisionId);
      } else {
        setMensaje({ tipo:'err', texto: r.error });
      }
    } finally {
      setReabriendoCuenta(false);
    }
  };

  const grupos = TIPOS_ITEM.reduce((acc, t) => {
    const itms = items.filter(i => i.tipo === t);
    if (itms.length > 0) acc[t] = itms;
    return acc;
  }, {});

  // Contar medicamentos controlados en la cuenta
  const ctControlados = items.filter(i =>
    (i.tipo==='Medicamento'||i.tipo==='Insumo') && i.num_receta
  ).length;

  return (
    <div style={{ fontFamily:'Segoe UI, sans-serif' }}>
      {ModalConfirmarUI}
      {/* ══ Header módulo — estandarizado ══ */}
      <div style={{ background:'linear-gradient(135deg,#1B2A5E,#0f1c40)', padding:'16px 24px' }}>
        <div style={{ fontSize:'19px', fontWeight:'800', color:'#fff', marginBottom:'3px' }}>
          🧾 Cuenta del Paciente
        </div>
        <div style={{ fontSize:'12px', color:'rgba(255,255,255,.8)' }}>
          Cargos · Servicios · Estado de cuenta por admisión
        </div>
      </div>

      <div style={S.pagina}>

      {!admisionId && (
        <div style={S.card}>
          <div style={S.cardTitulo}>Buscar expediente</div>

          {/* Búsqueda rápida por nombre, DUI o expediente */}
          <div style={{ marginBottom:'12px' }}>
            <label style={S.label}>🔍 Buscar por nombre del paciente, DUI o expediente</label>
            <div style={{ position:'relative' }}>
              <input
                style={{ ...S.input, paddingRight:'100px' }}
                placeholder="Escribe nombre, apellido, DUI o expediente..."
                value={textoBusq}
                onChange={e => { setTextoBusq(e.target.value); setMensaje(null); }}
              />
              {buscandoTexto && (
                <span style={{ position:'absolute', right:'10px', top:'50%', transform:'translateY(-50%)', fontSize:'11px', color:'#6c757d' }}>
                  Buscando...
                </span>
              )}
            </div>

            {resultsBusq.length > 0 && (
              <div style={{ border:'1px solid #dde3ea', borderRadius:'8px', marginTop:'4px', maxHeight:'240px', overflowY:'auto', background:'#fff', boxShadow:'0 4px 20px rgba(0,0,0,.12)' }}>
                {resultsBusq.map(a => (
                  <div key={a.id}
                    style={{ padding:'10px 14px', cursor:'pointer', fontSize:'13px', borderBottom:'1px solid #f0f4f8', display:'flex', justifyContent:'space-between', alignItems:'center' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0f4f8'}
                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                    onClick={() => {
                      setTextoBusq('');
                      setResultsBusq([]);
                      setMensaje(null);
                      setAdmisionId(a.id);
                    }}>
                    <div>
                      <strong style={{ color:'#1B2A5E' }}>{a.paciente}</strong>
                      <span style={{ color:'#6c757d', fontSize:'11px', marginLeft:'8px' }}>
                        {a.dui ? `DUI: ${a.dui}` : 'DUI: N/A'}
                        {a.paciente_codigo ? ` · Exp: ${a.paciente_codigo}` : ''}
                      </span>
                    </div>
                    <span style={{ fontSize:'11px', color:'#1D9E75', fontWeight:'700' }}>
                      Ver cuenta →
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Búsqueda directa manual */}
          <div style={{ display:'flex', gap:'10px' }}>
            <input style={{ ...S.input, flex:1 }}
              placeholder="Número de admisión o expediente (ej: 5 o 0001/2026)..."
              value={busAdmision}
              onChange={e => setBusAdmision(e.target.value)}
              onKeyDown={e => e.key==='Enter' && buscarAdmision()} />
            <button style={S.btnAzul} onClick={buscarAdmision}>Buscar</button>
          </div>
        </div>
      )}

      {mensaje && <div style={S.alerta(mensaje.tipo)}>{mensaje.texto}</div>}
      {cargando && <div style={{ textAlign:'center', padding:'40px', color:'#6c757d' }}>Cargando cuenta...</div>}

      {admision && !cargando && (
        <>
          {/* Info del paciente */}
          <div style={S.card}>
            <div style={S.cardTitulo}>
              <span>Expediente {admision.paciente_codigo ? admision.paciente_codigo : '#'+admision.id} — {admision.paciente}</span>
              <button style={S.btnSecundario}
                onClick={() => {
                  setAdmisionId(null); setAdmision(null); setItems([]);
                  setBusAdmision(''); setTextoBusq(''); setResultsBusq([]); setMensaje(null);
                }}>
                Cambiar expediente
              </button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:'14px', fontSize:'13px' }}>
              {[
                ['HABITACIÓN', admision.habitacion_num ? `${admision.habitacion_num} · ${admision.habitacion_tipo}` : 'Ambulatorio'],
                ['TIPO INGRESO', admision.tipo_ingreso],
                ['DÍAS', admision.dias],
                ['ESTADO', admision.estado],
                ['ESTADO CUENTA', admision.estado_cuenta || 'Activa'],
              ].map(([label, val]) => (
                <div key={label}>
                  <div style={{ color:'#6c757d', fontSize:'11px', marginBottom:'3px' }}>{label}</div>
                  <strong style={
                    label==='ESTADO' ? { color:admision.estado==='Activa'?'#1D9E75':'#856404' }
                    : label==='ESTADO CUENTA' ? { color: val==='Cerrada' ? '#dc3545' : '#1D9E75' }
                    : {}
                  }>
                    {val}
                  </strong>
                </div>
              ))}
            </div>

            {/* Aviso: cuenta cerrada por caja */}
            {admision.estado_cuenta === 'Cerrada' && (
              <div style={{ marginTop:'12px', padding:'10px 14px', background:'#f8d7da', borderRadius:'7px', fontSize:'12px', color:'#721c24', fontWeight:'600', display:'flex', alignItems:'center', gap:'8px' }}>
                🔒 Esta cuenta está cerrada. No se pueden agregar ni anular cargos. Ya puede facturarse.
              </div>
            )}

            {/* Aviso si hay controlados en la cuenta */}
            {ctControlados > 0 && (
              <div style={{ marginTop:'12px', padding:'8px 12px', background:'#f3e5f5', borderRadius:'7px', fontSize:'12px', color:'#6a1b9a', fontWeight:'600', display:'flex', alignItems:'center', gap:'8px' }}>
                ⚠️ Esta cuenta tiene {ctControlados} cargo{ctControlados!==1?'s':''} de medicamento{ctControlados!==1?'s':''} controlado{ctControlados!==1?'s':''}
                — registrado{ctControlados!==1?'s':''} con receta médica.
              </div>
            )}
          </div>

          {/* Cargos */}
          <div style={S.card}>
            <div style={S.cardTitulo}>
              <span>Cargos registrados ({items.length})</span>
              <div style={{ display:'flex', gap:'8px' }}>
                {admision.estado_cuenta !== 'Cerrada' && (
                  <button style={S.btnPrimario} onClick={() => setModalAbierto(true)}>+ Agregar cargo</button>
                )}
                <button style={S.btnSecundario} onClick={() => cargarCuenta(admisionId)}>Actualizar</button>
              </div>
            </div>

            {items.length === 0 ? (
              <p style={{ color:'#6c757d', fontSize:'13px', padding:'10px 0' }}>
                No hay cargos registrados. Usa el botón "Agregar cargo".
              </p>
            ) : (
              Object.entries(grupos).map(([tipo, itms]) => (
                <div key={tipo} style={{ marginBottom:'16px' }}>
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#6c757d', marginBottom:'6px', textTransform:'uppercase' }}>
                    {tipo}
                  </div>
                  <table style={S.tabla}>
                    <thead>
                      <tr>
                        {['Descripción','Lote','Receta / Prescriptor','Cant.','Precio unit.','Total','Por',''].map(h => (
                          <th key={h} style={S.th}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {itms.map(item => (
                        <tr key={item.id}
                          onMouseEnter={e => e.currentTarget.style.background='#f8fafd'}
                          onMouseLeave={e => e.currentTarget.style.background='transparent'}>

                          {/* Descripción */}
                          <td style={S.td}>
                            <span style={S.pill(item.tipo)}>{item.tipo}</span>
                            <span style={{ marginLeft:'8px' }}>{item.descripcion}</span>
                            {item.num_receta && (
                              <span style={S.badgeControlado}>CONTROLADO</span>
                            )}
                          </td>

                          {/* Lote */}
                          <td style={{ ...S.td, fontSize:'11px' }}>
                            {item.numero_lote ? (
                              <div>
                                <div style={{ fontWeight:'600', color:'#1B2A5E' }}>{item.numero_lote}</div>
                                {item.lote_vencimiento && (
                                  <div style={{ fontSize:'10px', color:'#6c757d' }}>
                                    Vence: {new Date(item.lote_vencimiento+'T00:00:00').toLocaleDateString('es-SV')}
                                  </div>
                                )}
                              </div>
                            ) : <span style={{ color:'#ccc' }}>—</span>}
                          </td>

                          {/* Receta / Prescriptor */}
                          <td style={{ ...S.td, fontSize:'11px' }}>
                            {item.num_receta ? (
                              <div>
                                <div style={{ fontWeight:'700', color:'#6a1b9a' }}>
                                  Rx: {item.num_receta}
                                </div>
                                {item.dr_prescriptor && (
                                  <div style={{ fontSize:'10px', color:'#7b1fa2' }}>
                                    {item.dr_prescriptor}
                                  </div>
                                )}
                              </div>
                            ) : <span style={{ color:'#ccc' }}>—</span>}
                          </td>

                          <td style={S.td}>{item.cantidad}</td>
                          <td style={S.td}>${Number(item.precio_unitario).toFixed(2)}</td>
                          <td style={{ ...S.td, fontWeight:'700', color:'#1B2A5E' }}>
                            ${Number(item.total).toFixed(2)}
                          </td>
                          <td style={{ ...S.td, fontSize:'11px', color:'#6c757d' }}>
                            {item.registrado_por}
                          </td>
                          <td style={S.td}>
                            {admision.estado_cuenta !== 'Cerrada' && (
                              <button style={S.btnPeligro} onClick={() => anularItem(item)}>Anular</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))
            )}
          </div>

          {/* Resumen */}
          <div style={{ ...S.card, maxWidth:'420px', marginLeft:'auto' }}>
            <div style={S.cardTitulo}>Resumen de cuenta</div>
            <div style={S.totalRow}><span style={{ color:'#6c757d' }}>Subtotal</span><span>${Number(totales.subtotal).toFixed(2)}</span></div>
            <div style={S.totalRow}><span style={{ color:'#6c757d' }}>IVA 13%</span><span>${Number(totales.iva).toFixed(2)}</span></div>
            <div style={S.totalFinal}><span>Total</span><span>${Number(totales.total).toFixed(2)}</span></div>

            {admision.estado_cuenta !== 'Cerrada' ? (
              <div style={{ marginTop:'14px' }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'6px' }}>
                  <button
                    style={{ ...S.btnPrimario, width:'100%', background:'#856404' }}
                    onClick={cerrarCuenta}
                    disabled={cerrandoCuenta || items.length === 0}>
                    {cerrandoCuenta ? '⏳ Cerrando...' : '🔒 Cerrar cuenta'}
                  </button>
                  <TooltipAyuda
                    texto="Una vez cerrada, no podrás agregar ni anular cargos. Solo se puede reabrir desde Facturación si aún no se ha generado la factura."
                  />
                </div>
                {items.length === 0 && (
                  <div style={{ fontSize:'11px', color:'#adb5bd', marginTop:'6px', textAlign:'center' }}>
                    Agrega al menos un cargo antes de cerrar la cuenta.
                  </div>
                )}
              </div>
            ) : (
              <div style={{ marginTop:'14px', display:'flex', gap:'8px' }}>
                <button style={S.btnAzul} onClick={() => onIrFacturacion && onIrFacturacion(admisionId)}>
                  Ir a facturación →
                </button>
                <button
                  style={{ ...S.btnSecundario, color:'#dc3545', borderColor:'#f5c6cb' }}
                  onClick={reabrirCuenta}
                  disabled={reabriendoCuenta}>
                  {reabriendoCuenta ? '⏳...' : '🔓 Reabrir'}
                </button>
              </div>
            )}
          </div>
        </>
      )}

      {modalAbierto && (
        <ModalAgregarItem
          admision_id={admisionId}
          usuario={usuario}
          onGuardado={() => {
            setModalAbierto(false);
            cargarCuenta(admisionId);
            setMensaje({ tipo:'ok', texto:'Cargo agregado correctamente.' });
            setTimeout(() => setMensaje(null), 3000);
          }}
          onCerrar={() => setModalAbierto(false)}
        />
      )}
      </div>
    </div>
  );
}
